"use strict";

exports.__esModule = true;
exports.default = findWhere;
var _find = _interopRequireDefault(require("./find.js"));
var _matcher = _interopRequireDefault(require("./matcher.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// Convenience version of a common use case of `_.find`: getting the first
// object containing specific `key:value` pairs.
function findWhere(obj, attrs) {
  return (0, _find.default)(obj, (0, _matcher.default)(attrs));
}